import { Injectable } from '@angular/core'
import { GoogleTagManagerService } from 'angular-google-tag-manager'
import { GtmEvents } from '@adex/shared/models/gtm-events'
import { environment } from '../../../environments'


@Injectable({
  providedIn: 'root'
})
export class GtmService {
  private uid: string
  private isInit = false

  constructor(private readonly gtmService: GoogleTagManagerService) {
    if (environment.production || environment.gtmDebug) {
      this.gtmService.addGtmToDom()
          .then(() => this.isInit = true)
          .catch(err => {
            if (environment.gtmDebug) console.error('gtm error add to dom', err)
          })
    }
  }

  public setUserId(uid: number): void {
    const strId = `adex-${ uid }`
    if (strId === this.uid) return
    this.uid = strId
    this.innerSend({ userID: this.uid })
  }

  public send(data: GtmEvents) {
    let d = { ...data }
    if ('eventLabel' in data && data.eventLabel) d = { ...data, eventLabel: this.uid } as any
    this.innerSend(d)
  }

  private innerSend(data: object) {
    if (!this.isInit) return
    if (!environment.production && !environment.gtmDebug) return
    if (environment.gtmDebug) console.log('gtm event', data)
    this.gtmService.pushTag({ ...data }).catch(err => console.warn(err))
  }
}
